export const ADMIN_ROLES = {
    owner: 'owner',
    canManageAdmins: 'canManageAdmins',
    canManageMembers: 'canMAnageMembers',

    canManageMessages: 'canManageMessages',

    canManageLoans: 'canManageLoans',
    canManageSavings: 'canManageSavings',
    canManageMemberCapital: 'canManageMemberCapital',
    canManageTransactions: 'canManageTransactions',

    canManageAccounting: 'canManageAccounting',

    canManageSettings: 'canManageSettings',

    canViewReports: 'canViewReports'
};
